import { Ruler } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

// "This picture carries measurements" — the model's answer, shown in the picture's
// bottom-left corner, and ONLY when it is yes. The caller places it (absolute, over the
// thumbnail) and draws it only for a flagged picture.
//
// NOT A SWITCH. It was one, on every thumbnail, so the classification could be corrected
// in either direction; the model's reading of it is trusted now, and a switch nobody is
// meant to press was a control that looked like a question.
//
// ONE COPY, for the Phase 1 strip and the Parts DB's photo grid — two views of the same
// pictures and the same flag.
export function DimensionBadge() {
  const { t } = useLanguage();
  return (
    <span
      title={t('notice.listing.dimensionedTip')}
      className="pointer-events-auto absolute bottom-1 left-1 inline-flex items-center gap-1 rounded-md bg-white/90 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-blue-700 shadow-sm backdrop-blur"
    >
      <Ruler className="h-3 w-3 shrink-0" />
      {t('notice.listing.dimensioned')}
    </span>
  );
}
